import React, {Component} from 'react';
import './CustomerGroupsList.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import CustomerGroupsLevelSelects from '../../CustomerGroupsLevel/CustomerGroupsLevelSelects/CustomerGroupsLevelSelects';
import CustomerGroupsInfluenceChangeSelects from '../../CustomerGroupsInfluenceChange/CustomerGroupsInfluenceChangeSelects/CustomerGroupsInfluenceChangeSelects';

class CustomerGroupsList extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            
        };
    }

    componentWillReceiveProps(nextProps){
        
    }

    deleteItem = (data) => {
        //this.props.deleteItem(data.groupId);
        // Open Modal
        this.props.deleteModalOpen(data.groupId);
    }

    onDataChange = () => {
        
      };

    render() {

        let groupsList =  _.map(this.props.getInfluencerMapGroupsData.Items[0].groups, (value, index) => {
           
            return (
                <li key={index}>
                    <p><strong>{value.groupName}</strong></p>
                    {this.props.groupStepState === 3 && <p>{value.level}</p> }
                    {this.props.groupStepState === 1 &&
                        <i onClick={() => this.deleteItem(value)} className="fas fa-trash-alt"></i>
                    }
                    
                    {this.props.groupStepState === 2 &&
                        <CustomerGroupsLevelSelects
                            data={value}
                            changeCustomerGroupLevel={this.props.changeCustomerGroupLevel}
                        />
                    }

                    {this.props.groupStepState === 3 &&
                        <CustomerGroupsInfluenceChangeSelects
                            data={value}
                            customerGroupInfluenceChange={this.props.customerGroupInfluenceChange}
                            //changeCustomerGroupLevel={this.props.changeCustomerGroupLevel}
                        />
                    }
                </li>
            )
            
          });

        return(
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='customer-groups-list-content'>
                        <ul>
                            {groupsList}
                        </ul>
                    </div>
                </div>
            </div>
        ) 
    }
}

export default (CustomerGroupsList);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerGroups/CustomerGroupsList/CustomerGroupsList.jsx